export const groupTransactions = (transactions) => {
  const today = new Date();

  const monthsPastDue = (dueDate) => {
    const d = new Date(dueDate);
    return (today.getFullYear() - d.getFullYear()) * 12 + (today.getMonth() - d.getMonth());
  };

  const creditNotes = transactions.filter(t => t.type === "CreditNote" && t.remainingAmount !== 0);
  const invoices = transactions.filter(t => t.type === "Invoice" && t.remainingAmount !== 0);

  const invoiceNumbers = new Set(invoices.map(i => i.transactionNumber));

  const invoiceEntries = invoices.map(invoice => {
    const associated = creditNotes.filter(cn => cn.originalTransactionNumber === invoice.transactionNumber);
    return {
      ...invoice,
      amount: invoice.remainingAmount,
      transactionDueDate: invoice.dueDate,
      associatedCreditNotes: associated.map(cn => ({
        ...cn,
        amount: cn.remainingAmount,
        transactionDueDate: cn.dueDate,
      })),
    };
  });

  const standaloneCreditNotes = creditNotes
    .filter(cn => !cn.originalTransactionNumber || !invoiceNumbers.has(cn.originalTransactionNumber))
    .map(cn => ({
      ...cn,
      amount: cn.remainingAmount,
      transactionDueDate: cn.dueDate,
      associatedCreditNotes: [],
    }));

  const buckets = {
    overdue: [],
    thisMonth: [],
    nextMonth: [],
    future: [],
  };

  [...invoiceEntries, ...standaloneCreditNotes].forEach(entry => {
    const mp = monthsPastDue(entry.dueDate);
    if (mp > 0) buckets.overdue.push(entry);
    else if (mp === 0) buckets.thisMonth.push(entry);
    else if (mp === -1) buckets.nextMonth.push(entry);
    else buckets.future.push(entry);
  });

  const byDueDate = (a, b) => new Date(a.transactionDueDate) - new Date(b.transactionDueDate);

  const getMonthName = (entries) =>
    new Date(entries[0].dueDate).toLocaleString("en-GB", { month: "long" });

  const groups = [];

  if (buckets.overdue.length > 0)
    groups.push({ name: "Overdue", invoices: buckets.overdue.sort(byDueDate) });

  if (buckets.thisMonth.length > 0)
    groups.push({ name: "Due this month", invoices: buckets.thisMonth.sort(byDueDate) });

  if (buckets.nextMonth.length > 0) {
    const sorted = buckets.nextMonth.sort(byDueDate);
    groups.push({ name: `Due in ${getMonthName(sorted)}`, invoices: sorted });
  }

  if (buckets.future.length > 0) {
    const sorted = buckets.future.sort(byDueDate);
    groups.push({ name: `Due in ${getMonthName(sorted)}`, invoices: sorted });
  }

  return groups;
};